// Node keys whose channel wraps its outbound links through the click-tracking host.
// The backend job gate only calls getTrackingUrl/getClickTrackingUrl for these -
// jobs/channels/webhooks.js, facebook-ad.js and google-ad.js never do - so blocking
// campaign activation on a missing click record only makes sense when the flow
// actually contains one of them. A key not in this list is treated as NOT gating:
// the backend gate is the real enforcement, so unblocking a node type we're unsure
// about is the safer default.
export const LINK_WRAPPING_NODE_KEYS = [
  'sendEmail',
  'sendTextMessage',
  'sendViberMessage',
  'sendWhatsappMessage',
  'sendPushNotification',
];

const flowHasLinkWrappingNode = (flow) =>
  flow?.nodes?.some((node) => LINK_WRAPPING_NODE_KEYS.includes(node.data?.custom?.key)) ?? false;

export default flowHasLinkWrappingNode;
